<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-big">
          Event
        </div>
        <div class="cell cell-big">Folder</div>
        <div class="cell cell-big">Date</div>
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedStep === step}"
        v-for="(step, index) in this.steps"
        :key="index"
        
      >
        <div class="cell cell-big">{{step.event}}</div>
        <div class="cell cell-big">{{step.folder}}</div>
        <div class="cell cell-big">{{new Date(step.timestamp).toLocaleDateString()}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";
import DynamicSimplifiedStepsList from "@/components/base/DynamicSimplifiedStepsList";

export default {
  components: {
    BaseIcon,
    BaseButton,
    MoreTableActions,
    LoadAmountList,
    DynamicSimplifiedStepsList
  },
  computed: {},
  props: {
    steps: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {
    this.qrS;
  },
  data() {
    return {
      selectedStep: null,
      sortingOn: "ref",
      isAscending: true,
      isOptionOpen: false,
      openOptions: "",
      isQROpen: false,
      qrString: [],
      openedQR: "",
      openedQRName: "",
      qrparameters: []
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";
@import "@/style/components/QRCodes.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}

.hidden {
  // visibility: hidden;
  display: none;
}

.fullscreen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba($color: #000000, $alpha: 0.16);

  display: flex;
  justify-content: center;
  align-items: center;

  .imageview {
    min-height: 320px;
    min-width: 320px;
    height: 44%;
    width: 22%;
    padding: 24px 40px;
    background-color: white;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.m {
      width: auto;
    }

    .print {
      margin-bottom: 16px;
    }

    .btn-close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 32px;
      height: 32px;

      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      background-color: none;
      border: none;

      .icon {
        font-size: 18px;
        color: #d0d0d0;
      }

      &:hover {
        background-color: none;
        cursor: pointer;
        .icon {
          font-size: 18px;
          color: #6a6a6a;
        }
      }
    }
  }
}
</style>
